import { Component } from '@angular/core';

@Component({
  selector: 'web-di-ld-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent {
  constructor() {}
}
